import { render, staticRenderFns } from "./DraftPriceRouteTab.vue?vue&type=template&id=110d67a4&"
import script from "./DraftPriceRouteTab.vue?vue&type=script&lang=js&"
export * from "./DraftPriceRouteTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports